import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { apologise } from '../redux-store/thunks/apology.thunks';
import { portalJwtUpdated } from '../redux-store/thunks/global.thunks';
import { JwtAPI } from '../api/jwt.api';

/**
 * Refreshes the portal JWT when a subscription is connected and the user is a portal admin.
 * `isPortalAdmin` is intentionally excluded from the effect's dependency array — the toggle
 * case is handled separately by `setPortalAdminPowerActivationState` to avoid a duplicate fetch.
 */
export const useRefreshJwtOnConnect = (args: {
  subId: string | undefined;
  connected: boolean;
  isPortalAdmin: boolean;
  portalUrl: string;
}) => {
  const { subId, connected, isPortalAdmin, portalUrl } = args;
  const dispatch = useDispatch();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (!subId || !isPortalAdmin || !connected) {
      return;
    }

    JwtAPI.get(portalUrl, subId)
      .then((token) => dispatch(portalJwtUpdated(token)))
      .catch((error) => dispatch(apologise(String(error))));
  }, [subId, connected, portalUrl, dispatch]);
};
